// extracted by mini-css-extract-plugin
module.exports = {"filtersWrapper":"styles_filtersWrapper__28Bla"};